import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../../../stores/CommonStore";
import Article from "../../../../entities/Article";
import { ArticleService } from "../../../../service/articleDelivery/ArticleService";

class ArticleSalePriceStore {

    public articles: Article[];
    public commonStore: CommonStore;
    public filter: string = "";

    constructor(commonStore: CommonStore) {
        this.articles = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            articles: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.articles.length === 0;
    }

    @action
    public setFilter(filer: string) {
        this.filter = filer;
        this.getArticles();
    }

    @action
    public async getArticles() {
        const response = await ArticleService.getAll(this.filter);
        if (response.success && response.data) {
            runInAction(() => {
                this.articles = response.data || [];
            })            
        }
    }

}

export default ArticleSalePriceStore;